<template>
    <div>
        <div class="row" v-show="styleDataErrors.lineStyleEmpty" id="line-style-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy wybrać styl linii.
            </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-line-style" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Styl linii</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-select v-model="lineStyle" :options="lineStylesList" id="single-symbol-line-style" :class="{ 'is-invalid': styleDataErrors.lineStyleEmpty }" aria-required="true" :aria-invalid="styleDataErrors.lineStyleEmpty" :aria-describedby="styleDataErrors.lineStyleEmpty ? 'line-style-empty-description' : ''"></b-form-select>
            </div>
        </div>
        <div class="row" v-show="styleDataErrors.lineWidthEmpty" id="line-width-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy podać szerokość linii.
            </small>
        </div>
        <div class="row" v-show="styleDataErrors.lineWidthNotInRange" id="line-width-range-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Szerokość linii powinna zawierać się w przedziale od 1 do 255.
            </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-line-width" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Szerokość linii</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-input v-model="lineWidth" type="number" id="single-symbol-line-width" min="1" max="255" class="form-control" :class="{ 'is-invalid': styleDataErrors.lineWidthEmpty || styleDataErrors.lineWidthNotInRange }" aria-required="true" :aria-invalid="styleDataErrors.lineWidthEmpty || styleDataErrors.lineWidthNotInRange" :aria-describedby="styleDataErrors.lineWidthEmpty ? 'line-width-empty-description' : (styleDataErrors.lineWidthNotInRange ? 'line-width-range-description' : '')"></b-form-input>             
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-fill-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor wypełnienia</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <color-picker v-model="fillColor" id="single-symbol-fill-color" />
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-style" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Styl obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-select v-model="strokeStyle" :options="strokeStylesList" id="single-symbol-stroke-style"></b-form-select>                 
            </div>
        </div>
        <div class="row" v-show="styleDataErrors.strokeSizeEmpty" id="stroke-size-empty-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Należy podać szerokość obrysu.
            </small>
        </div>
        <div class="row" v-show="styleDataErrors.strokeSizeNotInRange" id="stroke-size-range-description">
            <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
                Szerokość obrysu powinna zawierać się w przedziale od 1 do 255.
            </small>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-size" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Szerokość obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <b-form-input v-model="strokeSize" type="number" id="single-symbol-stroke-size" min="1" max="255" class="form-control" :class="{ 'is-invalid': styleDataErrors.strokeSizeEmpty || styleDataErrors.strokeSizeNotInRange }" :aria-required="strokeStyle !== null" :aria-invalid="styleDataErrors.strokeSizeEmpty || styleDataErrors.strokeSizeNotInRange" :aria-describedby="styleDataErrors.strokeSizeEmpty ? 'stroke-size-empty-description' : (styleDataErrors.strokeSizeNotInRange ? 'stroke-size-range-description' : '')"></b-form-input>             
            </div>
        </div>
        <div class="form-group row">
            <label for="single-symbol-stroke-color" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Kolor obrysu</label>
            <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-9': size === 'lg'}">
                <color-picker v-model="strokeColor" id="single-symbol-stroke-color" />
            </div>
        </div>
    </div>
</template>

<script>
import ColorPicker from "../../ColorPicker.vue";
import LayerStyleStore from "../store/LayerStyleStore";

export default {
  name: "FormLayerStyleLineSingleSymbol",
  props: {
    size: String
  },
  data() {
    return {
      lineStyle: [1],
      lineWidth: 12,
      fillColor: { r: 255, g: 255, b: 0, a: 1 },
      strokeStyle: [1],
      strokeSize: 3,
      strokeColor: { r: 255, g: 0, b: 255, a: 1 },
      lineStylesList: [
        { text: "Wybierz", value: null },
        { text: "Przerywana", value: [4, 4] },
        { text: "Kropkowana", value: [1, 1] },
        { text: "Ciągła", value: [1] }
      ],
      strokeStylesList: [
        { text: "Wybierz", value: null },
        { text: "Kreskowany", value: [4, 4] },
        { text: "Kropkowany", value: [1, 1] },
        { text: "Ciągły", value: [1] }
      ],
      styleDataErrors: {
        lineStyleEmpty: false,
        lineWidthEmpty: false,
        lineWidthNotInRange: false,
        strokeSizeEmpty: false,
        strokeSizeNotInRange: false
      }
    };
  },
  mounted() {
    let store = new LayerStyleStore();
    const initialValue = store.getLineSingleSymbol();
    if (initialValue != null && initialValue.reguly !== undefined && initialValue.reguly.length !== 0) {
      this.lineStyle = initialValue.reguly[0].sygnatura.wypelnienie.kreskowanie;
      this.lineWidth = initialValue.reguly[0].sygnatura.wypelnienie.szerokosc;
      this.fillColor = initialValue.reguly[0].sygnatura.wypelnienie.kolor;
      this.strokeStyle = initialValue.reguly[0].sygnatura.obrys.kreskowanie;
      this.strokeSize = initialValue.reguly[0].sygnatura.obrys.szerokosc;
      this.strokeColor = initialValue.reguly[0].sygnatura.obrys.kolor;
    }
  },
  methods: {
    updateValue() {
      let store = new LayerStyleStore();
      store.setLineSingleSymbol({
        reguly: [
        {
          filtr: null,
          sygnatura: {
            obrys: {
              kolor: this.strokeColor,
              kreskowanie: this.strokeStyle,
              szerokosc: this.strokeSize ? parseInt(this.strokeSize) : null
            },
            wypelnienie: {
              kolor: this.fillColor,
              kreskowanie: this.lineStyle,
              szerokosc: this.lineWidth ? parseInt(this.lineWidth) : null
            }
          }
        }
      ]});
      this.$emit('updated');
    },
    validate() {
      this.updateValue();
      var vm = this;
      Object.keys(this.styleDataErrors).forEach(
        x => (vm.styleDataErrors[x] = false)
      );
      if (this.lineStyle === null) {
        this.styleDataErrors.lineStyleEmpty = true;
      }
      if (this.lineWidth === "") {
        this.styleDataErrors.lineWidthEmpty = true;
      } else if (this.lineWidth < 1 || this.lineWidth > 255) {
        this.styleDataErrors.lineWidthNotInRange = true;
      }
      if (this.strokeStyle !== null) {
        if (this.strokeSize === "") {
          this.styleDataErrors.strokeSizeEmpty = true;
        } else if (this.strokeSize < 1 || this.strokeSize > 255) {
          this.styleDataErrors.strokeSizeNotInRange = true;
        }
      }
      return Object.keys(this.styleDataErrors).some(
        x => vm.styleDataErrors[x] === true
      );
    }
  },
  components: {
    ColorPicker
  }
};
</script>